import React from "react";
import { skills } from "../data/data";
import "../styles/Skills.css";

function Skills() {
  return (
    <div className="skills" id="skills">
      <h1>Skills</h1>
      <div className="icon-container">
        {skills.map((el, i) => (
          <div key={i} className="icon">
            <img src={el.url} alt="icon" />
            <p>{el.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Skills;
